export const FREESTAR_STICKY_FOOTER_DISMISS_STORAGE_KEY = 'hideFreestarStickyFooter';

export const queryFreestarStickyFooterElement = (): HTMLElement | null => {
  if (typeof document === 'undefined') return null;
  return (
    document.getElementById('fs-sticky-footer') ||
    document.querySelector<HTMLElement>('.fs-sticky-footer') ||
    document.getElementById('fs-slot-footer-wrapper')
  );
};

export const isFreestarStickyFooterDismissed = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(FREESTAR_STICKY_FOOTER_DISMISS_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

export const persistFreestarStickyFooterDismiss = (): void => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(FREESTAR_STICKY_FOOTER_DISMISS_STORAGE_KEY, 'true');
  } catch {
    return;
  }
};
